
const EmailStyle = theme => ({
    emailWrapper: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "auto"
    },
    fixEmailHeaderWrapper: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
    },
    tableHeader: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flex: 1,
        minHeight: 35,
        maxHeight: 35,
        backgroundColor: "#eaeded"
    },
    emptyRow: {
        paddingTop: 14,
        paddingLeft: 43,
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "18px",
        letterSpacing: 0,
        lineHeight: "22px",
        display: "flex",
        flexDirection: "column",
        minHeight: 100
    },
    iconSection: {
        width: 30,
        display: "flex",
        justifyContent: "center",
        marginRight: "20px",
        marginLeft: 20,
        maxHeight: 17,
        minWidth: 30,
    },
    dateSection: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        width: 150,
        marginRight: "20px"
    },
    toSection: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        width: 240,
        marginRight: "20px"
    },
    fromSection: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        width: 240,
        marginRight: "20px"
    },
    subjectSection: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "16px",
        fontWeight: "bold",
        letterSpacing: 0,
        lineHeight: "20px",
        display: "flex",
        flex: 1,
        marginRight: "20px"
    },
    EmailRowWrapper: {
        borderBottom: "2px solid #ededed",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        flexShrink:0,
        paddingTop: 6.5,
        paddingBottom: 6.5,
        backgroundColor: "#ffffff"
    },
    EmailOddRowWrapper: {
        flexShrink:0,
        backgroundColor: "#fafafa !important"
    },
    EmailRow: {
        display: "flex",
    },
    EmailMessageRow: {
        display: "flex",
        wordBreak: "break-all"
    },
    EmailMessageHiddenRow: {
        display: "flex",
        height: 0,
        maxHeight: 0,
        minHeight: 0,
        overflow: "hidden"
    },
    expandIconStyle: {
        margin: 0,
        padding: "0px !important",
        height: 16,
        width: 16,
        borderRadius: "100%",
        verticalAlign: "unset"
    },
    expanIcon: {
        height: 17,
        width: 17,
        transition: "all .5s ease",
        transform: "rotateZ(0deg)"
    },
    reverseExpanIcon: {
        transform: "rotateZ(180deg) !important"
    },
    dateRowStyle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        marginRight: 20,
        lineHeight: "17px",
        width: 150,
        minWidth: 150,
    },
    toRowStyle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        marginRight: 20,
        lineHeight: "17px",
        width: 240,
        minWidth: 240,
    },
    fromRowStyle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        letterSpacing: 0,
        marginRight: 20,
        lineHeight: "17px",
        width: 240,
        minWidth: 240,
    },
    subjectRowStyle: {
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        display: "flex",
        flex: 1,
        letterSpacing: 0,
        marginRight: 20,
        lineHeight: "17px",
    },
    messageRowStyle: {
        marginTop: 13,
        color: "#242424",
        fontFamily: "Proxima Nova",
        fontSize: "14px",
        display: "flex",
        flex: 1,
        flexDirection: "column",
        whiteSpace: "pre-wrap",
        letterSpacing: 0,
        paddingRight: 20,
        lineHeight: "17px",
    },
    ellipsis: {
        whiteSpace: "pre-wrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block !important",
        width: "100%"
    }
})

export default EmailStyle;